<div fxFlex fxLayout="column" fxLayoutAlign="start stretch" fxFlexFill>
    <div fxFlex>
        <mat-toolbar color="primary">
            <!-- Hard Coded text for slagboom, change in future if more organizations need this -->
            @if (organizationId === 23 || organizationId === 30) {
                <span class="mat-h3 m-0">Short Term / Out Of Phase Item Next Due Maintenance</span>
            } @else {
                <span class="mat-h3 m-0">Short Term / High Frequency Next Due Maintenance</span>
            }
            <span class="spacer"></span>
            @if (isCamo) {
                <button mat-raised-button (click)="openUpdateShortItemDialog()" class="mr-10">
                    {{ "HTL.SHORTITEM.addNewInspection" | translate }}
                </button>
            }
            <mat-form-field style="height: 100%">
                <mat-select [(ngModel)]="selectedAircraftOption" (selectionChange)="chooseAircraft($event.value)">
                    @for (item of aircraftOptions; track item) {
                        <mat-option [value]="item.value">{{ item.name }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </mat-toolbar>
    </div>
    <div fxLayout="row" fxFlexFill>
        <!--
  <div style="max-height: calc(100vh - 130px); overflow: auto; width: 100%">
    <mat-nav-list role="navigation" class="p-0">
      @for (helicopter of helicoptersArray; track $index) {
        <div (click)="chooseAircraft(helicopter)" class="aircraft" [ngClass]="{'is-active': helicopter.id === chosenAircraft?.id}">
          <div fxLayout="row">
            <mat-icon mat-list-icon class="m-15">flight_takeoff</mat-icon>
            <div mat-line class="mt-15" style="font-size: medium;">{{helicopter.registrationMark}}</div>
          </div>
        </div>
      }
    </mat-nav-list>
  </div>
  -->
        <mat-divider [vertical]="true"></mat-divider>
        <div style="max-width: 99% !important; height: calc(100vh - 130px)">
            <app-next-due-maintenance-table
                #table
                (dataLoaded)="onDataLoaded($event)"
                (tabChanged)="onTabChange($event)"
                [aircraft]="chosenAircraft"
                [helicopterData]="helicopterData"
                [helicopterWarnings]="helicopterWarnings"
                [helicopterHooks]="helicopterHooks"
                [helicopterHoists]="helicopterHoists"
                style="height: 100%"
            >
            </app-next-due-maintenance-table>
        </div>
    </div>
</div>
